export default __webpack_public_path__ + "static/media/1128040325510229.fd5fd61c.jpg";